import React from "react";
import Helmet from "react-helmet";
import Menu from "../components/Menu/Menu";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Projects from "../components/Projects/Projects";
import Hero from "../components/Hero/Hero";
import Contact from "../components/Contact/Contact";
import HomeContent from "../components/HomeContent/HomeContent";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import ToTopButton from "../components/ToTopButton/ToTopButton";
import LeftPictureBackground from "../components/Section/LeftPictureBackground";
import picture from "../../static/images/Responsive-Web-Design-PNG-File.png";
import Clear from "../components/Structure/Clear";
import "../../static/styles/app.scss";
import "../../static/styles/home.scss";

class Index extends React.Component {
    render() {

        let smalltitle = "Des applications uniques";
        let title = "Un studio Web sur-mesure";
        let description = ["Chaque organisation et chaque projet à des besoins différents. ", <br />, <br />," C'est pourquoi nous proposons de réaliser, pour vous, des applications ou sites Web uniques, sur-mesure et adaptées à vos besoins sous quelque support que ce soit."];
        let alt = "Réalisation d'applications Web responsive";

        const postNode = {
          "frontmatter": {
              "title": "Integral Service - Studio Web Lyon - Experts en développement Web et Mobile",
              "description":  "Integral Service est une agence web Lyonnaise qui vous accompagne et réalise des projets Web et mobile sur-mesure.",
              "cover": "/images/integral-service-sem.png"
          }
      };

        return (
            <div id="outer-container">
                <Helmet title="Integral Service - Studio Web Lyon - Experts en développement Web et Mobile"
                description = {`Integral Service est une agence web Lyonnaise qui vous accompagne et réalise des projets Web et mobile sur-mesure.`}
                />
                <SEO postPath="" postNode={postNode}  postSEO/>
                <Menu/>
                <div id="page-wrap">
                  <main id="fh5co-page">
                      <Header />
                      <div>
                          <Hero/>
                          <Projects/>
                          <LeftPictureBackground smalltitle={smalltitle} title={title} description={description} picture={picture} alt={alt}/>
                          <HomeContent/>
                          <Contact/>
                          <Clear/>
                          <Footer/>
                          <ToTopButton/>
                      </div>
                  </main>
                </div>
            </div>
        );
    }
}

export default Index;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx